import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shd-app-gov-header',
  standalone: true,
  imports:[ CommonModule],
  templateUrl: './govheader.component.html',
  styleUrls: ['./govheader.component.css']
})
export class GovHeaderComponent {

  selectedMenu = 'inicio';
  
}
